/**
 * Infrastructure-Health Fixture.
 * Quelle: 01_apis/01_core.api.valitype.net/ADMIN/views.md → #/infra
 */

export function infraFixture() {
  const now = Date.now();
  return {
    db: {
      ok: true,
      latencyMs: 4 + Math.round(Math.random() * 3),
      version: 'PostgreSQL 16.3',
      pool: { idle: 18, active: 2, total: 20 },
    },
    redis: {
      ok: true,
      latencyMs: 1,
      version: '7.4.0',
    },
    queues: [
      { name: 'webhook-out', waiting: 12, active: 2, failed: 1 },
      { name: 'mail-send', waiting: 4, active: 1, failed: 0 },
      { name: 'audit-write', waiting: 0, active: 0, failed: 0 },
      { name: 'vat-reverify', waiting: 1, active: 0, failed: 0 },
    ],
    workers: [
      { id: 'worker-1', heartbeatAt: new Date(now - 8_000).toISOString(), status: 'healthy', pid: 12_345 },
      { id: 'worker-2', heartbeatAt: new Date(now - 12_000).toISOString(), status: 'healthy', pid: 12_346 },
      { id: 'worker-3', heartbeatAt: new Date(now - 4 * 60_000).toISOString(), status: 'stale', pid: 12_347 },
    ],
    build: {
      version: '1.4.2',
      sha: 'a930576',
      builtAt: new Date(now - 3 * 86_400_000).toISOString(),
      node: 'v20.18.0',
    },
    checkedAt: new Date(now).toISOString(),
  };
}
